import 'babel-polyfill'
import Vue from 'vue'
import App from './App.vue'
import Router from './router'
import VueGtag from "vue-gtag";

Vue.config.productionTip = false

Vue.use(VueGtag, {
  config: { id: "UA-179830292-1" },
}, Router);

new Vue({
  router: Router,
  render: h => h(App)
}).$mount('#app')
